import * as React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  TextField,
  Button,
  Box,
  Stack,
  Card,
  CardContent,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff, Lock } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { _post } from "../../Config/axiosInstance";
function SimpleDialog({ onClose, selectedValue, open, loginId }) {
  const passwordRef = React.useRef();
  const retypePasswordRef = React.useRef();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);
  const [showRetype, setShowRetype] = React.useState(false);

  const toggleShowPassword = () => setShowPassword((prev) => !prev);
  const toggleShowRetype = () => setShowRetype((prev) => !prev);

  const handleClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      onClose("navigateHome");
    } else {
      onClose(selectedValue);
    }
  };

  const performResetAction = async () => {
    const password = passwordRef.current.value;
    const retypePassword = retypePasswordRef.current.value;

    if (password !== retypePassword) {
      alert("Passwords do not match!");
      return;
    }
    if (password === "1234") {
      alert("Default password again? Nope!");
      return;
    }

    const passwordData = {
      password,
      retypePassword,
      loginId,
    };
    try {
      const response = await _post("/resetpassword", passwordData);
      onClose("Password Reset Done");
      navigate("/");
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
      <Card elevation={6} sx={{ borderRadius: 4 }}>
        <CardContent>
          <DialogTitle>
            <Typography variant="span" textAlign="center">
              🔒 Reset Your Password
            </Typography>
          </DialogTitle>
          <Box sx={{ px: 2, pb: 3 }}>
            <Stack spacing={3}>
              <TextField
                inputRef={passwordRef}
                label="New Password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleShowPassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                inputRef={retypePasswordRef}
                label="Confirm Password"
                type={showRetype ? "text" : "password"}
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleShowRetype} edge="end">
                        {showRetype ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={performResetAction}
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                  borderRadius: 2,
                  py: 1.5,
                }}
              >
                Reset Password
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

//export default SimpleDialog;

const ResetPassword = () => {
  const location = useLocation();
  const loginId = location.state?.loginId;
  const [open, setOpen] = React.useState(true);
  const [selectedValue, setSelectedValue] = React.useState("");
  const navigate = useNavigate();
  console.log("loginId", loginId);
  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);

    if (value === "navigateHome") {
      navigate("/"); // 👈 home sweet home
    }
  };

  return (
    <div>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
        loginId={loginId}
      />
    </div>
  );
};

export default ResetPassword;
